import Glide from "@glidejs/glide";

import Reviews from "../../components/Reviews.js";
import OccasionsComponent from "../../components/Occasions.js";
import FeaturedComponent from "../../components/Featured.js";
import LocationsListComponent from "../../components/LocationsList.js";
import LocationWalkins from "../../components/LocationWalkins.js";
import LocationWalkinsFull from "../../components/LocationWalkinsFull.js";
import LocationFaqs from "../../components/LocationFaqs.js";
import ImageCarousel from "../../components/ImageCarousel.js";
import LocationNearYou from "../../components/LocationNearYou.js";
import GoogleReviews from "../../components/GoogleReviews.js";

window.Glide = Glide;

if (document.getElementById("reviews-component")) {
  if (!customElements.get("reviews-component")) {
    customElements.define("reviews-component", Reviews);
  }
}

if (document.getElementById("occasions-component")) {
  if (!customElements.get("occasions-component")) {
    customElements.define("occasions-component", OccasionsComponent);
  }
}

if (document.getElementById("featured-component")) {
  if (!customElements.get("featured-component")) {
    customElements.define("featured-component", FeaturedComponent);
  }
}

if (document.getElementById("locations-list-component")) {
  if (!customElements.get("locations-list-component")) {
    customElements.define("locations-list-component", LocationsListComponent);
  }
}

if (document.getElementById("location-walkins")) {
  if (!customElements.get("location-walkins-component")) {
    customElements.define("location-walkins-component", LocationWalkins);
  }
}

if (document.getElementById("faqs-component")) {
  if (!customElements.get("location-faqs-component")) {
    customElements.define("location-faqs-component", LocationFaqs);
  }
}

if (document.getElementById("location-walkins-full-box")) {
  if (!customElements.get("location-walkins-full-component")) {
    customElements.define("location-walkins-full-component", LocationWalkinsFull);
  }
}

if (!customElements.get("bat-image-carousel")) {
  customElements.define("bat-image-carousel", ImageCarousel);
}

if (!customElements.get("location-near-you")) {
  customElements.define("location-near-you", LocationNearYou);
}

if (!customElements.get("google-reviews")) {
  customElements.define("google-reviews", GoogleReviews);
}
